export const listOf = (value: string | undefined) => (value ?? "").split(",").filter(Boolean);

export function toggled(value: string | undefined, key: string): string | undefined {
  const set = new Set(listOf(value));
  if (set.has(key)) set.delete(key);
  else set.add(key);
  return set.size === 0 ? undefined : [...set].join(",");
}
